export default __webpack_public_path__ + "static/media/dry_cool.74e56e79.svg";